var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyPage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 5.8335C17.4147 5.8335 18.7712 6.3954 19.7714 7.39559C20.7716 8.39579 21.3335 9.75234 21.3335 11.1668C21.3335 12.5813 20.7716 13.9379 19.7714 14.9381C18.7712 15.9383 17.4147 16.5002 16.0002 16.5002C14.5857 16.5002 13.2291 15.9383 12.2289 14.9381C11.2287 13.9379 10.6668 12.5813 10.6668 11.1668C10.6668 9.75234 11.2287 8.39579 12.2289 7.39559C13.2291 6.3954 14.5857 5.8335 16.0002 5.8335ZM16.0002 19.1668C21.8935 19.1668 26.6668 21.5535 26.6668 24.5002V27.1668H5.3335V24.5002C5.3335 21.5535 10.1068 19.1668 16.0002 19.1668Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPage);
export default __webpack_public_path__ + "static/media/my-page.49c480969849c4abffff192e42a4bb2d.svg";
export { ForwardRef as ReactComponent };